<template>
  <v-layout wrap>
    <v-flex xs12>
      <h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px">{{$t('food.allergens')}}</h5>
    </v-flex>
    <div class="allergens-main">
      <div
        v-for="(allergen) in allergens"
        :key="allergen.ID"  
        class="allergens-item" 
      >
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <table v-on="on">
              <tr>
                <td style="vertical-align : middle;">
                  <v-checkbox
                    v-model="selectedAllergens"
                    :color="enterpriseColor"
                    :value="allergen.ID"
                    @change="handleChangeIsModified"
                  />
                </td>
                <td style="vertical-align : middle;">
                  <img
                    :src="`https://www.dtouch.es/assets/allergens/${allergen.Image}.png`"
                    width="50px"
                    heigth="auto"
                    alt="logo"
                    style="margin: 5px;"
                  >
                </td>
              </tr>
            </table>
          </template>
          <span>{{ allergen.Name }}</span>
        </v-tooltip>
      </div>
    </div>
  </v-layout>
</template>
<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import utils from '@/services/utils'
  export default {
    props: {
      value: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      selectedAllergens: [],
      allergens: null
    }),
    computed: {
      ...mapState('app',['locale']),
      languages () {
        return this.$store.state.app.Languages
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    watch: {
      value (v) {
        if (v) this.selectedAllergens = v
      }
    },
    mounted () {
      this.selectedAllergens = this.value ? this.value : []
      const enterpriseIDDomain = this.$store.state.app.enterpriseID ? this.$store.state.app.enterpriseID : utils.getDomain()
      api.getItem('utils', true, `allergens/${enterpriseIDDomain}`).then(response => {
        this.allergens = response.data.map(item => {
          item.Name = utils.getTranslation (item.Name, this.locale) 
          return item
        })
      })
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
        this.$emit('input', this.selectedAllergens)
      }
    }
  }
</script>

<style scoped>
  .allergens-main {
    width: 100%;
  }
  .allergens-item {
    float: left;
    padding-right: 10px;
  }
</style>
